<template>
  <div class="ms-cell-editor checkbox">
    <input ref="inputFake" class="fake-input" :disabled="disabled" @keydown="onKeyDown" @click="clickEditor" />
    <div class="cell-checkbox-combobox" :class="{'active-cell': isEditor}">
      <div class="icon" :class="{checked: dataRow[col.dataField]}"></div>
    </div>
  </div>
</template>
<script>
import msCellInput from './MsCellInput.vue';
import {ref} from 'vue';
export default {
  name: 'MsCellCheckbox',
  extends: msCellInput,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change', 'update:modelValue', 'msKeydown', 'pasteInput'],
  setup(props, {emit}) {
    const isEditor = ref(false);

    /**
     * Gán giá trị cho cell
     */
    const setValue = async value => {
      let me = proxy;

      if (value) {
        cellData.value = true;
      } else {
        cellData.value = false;
      }
      emit('update:modelValue', cellData.value);
    };

    return {isEditor, setValue};
  },

  methods: {
    changeHandler(value) {
      const me = this;
      const metaData = {
        dataRow: me.dataRow,
        column: me.col,
        newValue: value,
        cell: me,
      };
      me.$emit('change', metaData);
      this.activeToFakeInput();
    },
    /**
     * Xử lý phím space
     * NCPHUOC 21/07/2022
     */
    onKeyDown(e) {
      if (this.col.editable) {
        if (e.keyCode === this.$ms.constant.KeyCode.Space) {
          this.submitCell();
          this.$nextTick(() => {
            this.activeToFakeInput();
          });
        }
      }
      // Loại bỏ các event bên ngoài(tab,nhập liệu,mũi tên) để xử lý theo grid
      e.preventDefault();
      e.stopPropagation();

      this.$emit('msKeydown', e);
    },
    /**
     * Tự động focus vào input fake để bắt sự kiện gõ phím
     * NCPHUOC 21/07/2022
     */
    activeCell() {
      this.activeToFakeInput();
      this.isEditor = true;
    },
    /**
     * dispose editor
     * NCPHUOC 21/07/2022
     */
    inactiveCell() {
      this.isEditor = false;
    },
    /**
     * active vào fake input khi nó tác động từ bên ngoài
     * NCPHUOC 21/07/2022
     */
    activeToFakeInput() {
      const me = this;
      const inputFake = me.$refs['inputFake'];
      if (inputFake) {
        inputFake.focus();
      }
    },

    /**
     * Submit giá trị cell
     * NCPHUOC 21/07/2022
     */
    submitCell() {
      this.$emit('update:modelValue', !this.dataRow[this.col.dataField]);
    },
    /**
     * Click vào cell sẽ thực hiện update luôn do cell checkbox sẽ ko mở ra nhập liệu như cell input
     * NCPHUOC 21/07/2022
     */
    clickEditor(e) {
      if (this.col.editable) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$emit('update:modelValue', !this.dataRow[this.col.dataField]);
          });
        });
        // Emit ra để grid bắt sk
        this.$emit('editorClick', e, this.col, this.colIndex);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  position: relative;
  text-align: center;
  .justify-center {
    height: 100%;
  }
  .fake-input {
    background: rgba(255, 255, 255, 0);
    overflow: hidden;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
    cursor: pointer;
    opacity: 0;
    left: 0px;
  }
  input {
    border: unset;
  }
  .cell-checkbox-combobox {
    height: 100%;
    &.active-cell {
      border: 1px solid #14aa8a;
      border-radius: 2px;
    }
  }
}
</style>
